import { environment } from "src/environments/environment";
import { MenuCotacaoItem } from "../components/menu-nova-cotacao/menu-nova-cotacao";

function isMobileDevice(): boolean {
    const userAgent = navigator.userAgent;
    return /android|iphone|ipad|ipod|blackberry|opera mini|iemobile|wpdesktop/i.test(userAgent);
}

export const menuCotacao_new: MenuCotacaoItem[] = [
    {
        id: 1,
        titulo: "Automóvel",
        showIfAuthorizedName: "TITULO_AUTOMOVEL",
        list: [
            {
                id: 11,
                txt: "Carro",
                icone: 'car-hatchback',
                url: '/cotacao/auto/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_auto',
                    label: 'Iniciando nova cotação Auto'
                },
                showIfAuthorizedName: "AUTO"
            },
            {
                id: 12,
                txt: "Caminhão",
                icone: 'heroTruckSolid',
                url: '/cotacao/caminhao/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_caminhao',
                    label: 'Iniciando nova cotação Caminhão'
                },
                showIfAuthorizedName: "CAMINHAO"
            },
            {
                id: 13,
                txt: "Motocicleta",
                icone: 'motorbike',
                url: '/cotacao/motocicleta/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_motocicleta',
                    label: 'Iniciando nova cotação Motocicleta'
                },
                 showIfAuthorizedName: "MOTO"
            },
        ]
    },
    {
        id: 2,
        titulo: "Compreensivos",
        showIfAuthorizedName: "TITULO_COMPREENSIVOS",
        list: [
            {
                id: 21,
                txt: "Residencial",
                icone: 'residencial',
                url: '/cotacao/residencial/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_residencial',
                    label: 'Iniciando nova cotação Residencial'
                },
                showIfAuthorizedName: "RESIDENCIAL"
            },
            {
                id: 22,
                txt: "Condomínio",
                icone: 'condominio',
                url: '/cotacao/condominio/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_condominio',
                    label: 'Iniciando nova cotação Condomínio'
                },
                showIfAuthorizedName: "CONDOMINIO"
            },
            {
                id: 23,
                txt: "Empresarial",
                icone: 'empresarial',
                url: '/cotacao/empresarial/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_empresarial',
                    label: 'Iniciando nova cotação Empresarial'
                },
                showIfAuthorizedName: "EMPRESARIAL"
            }
        ]
    },
    {
        id: 3,
        titulo: "Vida",
        showIfAuthorizedName: "TITULO_VIDA",
        list: [
            {
                id: 31,
                txt: "Vida Individual",
                icone: 'vida-individual',
                url: '/cotacao/vida/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_vida',
                    label: 'Iniciando nova cotação Vida'
                },
                showIfAuthorizedName: "VIDA"
            },
            {
                id: 32,
                txt: "Vida Global",
                icone: 'vida-global',
                url: '/cotacao/vida_global/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_vida_global',
                    label: 'Iniciando nova cotação Vida Global'
                },
                showIfAuthorizedName: "VIDA_GLOBAL"
            },
            {
                id: 33,
                txt: "Acidentes Pessoais",
                icone: 'account-injury',
                url: '/cotacao/acidentes_pessoais/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_acidentes_pessoais',
                    label: 'Iniciando nova cotação Acidentes Pessoais'
                },
                showIfAuthorizedName: "ACIDENTES_PESSOAIS"
            },
            {
                id: 34,
                txt: "Viagem",
                icone: 'bag-suitcase',
                url: '/cotacao/viagem/formulario',
                analytics: {
                    type: 'click',
                    category: 'nova_cotacao_viagem',
                    label: 'Iniciando nova cotação Viagem'
                },
                showIfAuthorizedName: "VIAGEM"
            }
        ]
    },
    {
        id: 4,
        titulo: "Diversos",
        showIfAuthorizedName: "TITULO_DIVERSOS",
        list: [
            {
                id: 41,
                txt: "Aluguel",
                icone: 'key-chain-variant',
                url: '/cotacao/aluguel/formulario',
                analytics: {
                    type: 'click',
                    category: 'aluguel',
                    label: 'Iniciando nova cotação Aluguel'
                },
                showIfAuthorizedName: "ALUGUEL"
            },
            {
                id: 42,
                txt: "Bike",
                icone: 'bicycle',
                url: '/cotacao/bike/formulario',
                analytics: {
                    type: 'click',
                    category: 'bike',
                    label: 'Iniciando nova cotação Bike'
                },
                showIfAuthorizedName: "BIKE"
            },
            {
                id: 43,
                txt: "Celular",
                icone: 'smartphone',
                url: '/cotacao/celular/formulario',
                analytics: {
                    type: 'click',
                    category: 'celular',
                    label: 'Iniciando nova cotação Celular'
                },
                showIfAuthorizedName: "CELULAR"
            }
        ]
    },
    {
          id: 5,
          titulo: "Saúde",
          showIfAuthorizedName: "TITULO_SAUDE",
          list: [
              {
                  id: 44,
                  txt: "Saúde",
                  icone: 'stethoscope',
                  url: '/cotacao/saude/formulario',
                  analytics: {
                      type: 'click',
                      category: 'saude',
                      label: 'Iniciando nova cotação saude'
                  },
                  showIfAuthorizedName: "SAUDE"
              },
          ]
      }
]

export const menuCotacao = [
    {
        titulo: 'Automóvel',
        url: '/cotacao/auto/formulario', 
        icone: 'car-hatchback',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_auto',
            label: 'Iniciando nova cotação Auto'
        }
    },
    {
        titulo: 'Caminhão', 
        url: '/cotacao/caminhao/formulario', 
        icone: 'truck',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_caminhao',
            label: 'Iniciando nova cotação Caminhão'
        }
    },
    {
        titulo: 'Moto', 
        url: '/cotacao/motocicleta/formulario', 
        icone: 'motorbike',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_motocicleta',
            label: 'Iniciando nova cotação Motocicleta'
        }
    },
    {
        titulo: 'Residencial', 
        url: '/cotacao/residencial/formulario', 
        icone: 'home',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_residencial',
            label: 'Iniciando nova cotação Residencial'
        }
    },
    {
        titulo: 'Condomínio', 
        url: '/cotacao/condominio/formulario', 
        icone: 'domain',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_condominio',
            label: 'Iniciando nova cotação Condomínio'
        }
    },
    {
        titulo: 'Empresarial', 
        url: '/cotacao/empresarial/formulario', 
        icone: 'factory',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_empresarial',
            label: 'Iniciando nova cotação Empresarial'
        }
    },
    {
        titulo: 'Vida', 
        url: '/cotacao/vida/formulario', 
        icone: 'cards-heart',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_vida',
            label: 'Iniciando nova cotação Vida'
        }
    },
    {
        titulo: 'Vida Global', 
        url: '/cotacao/vida_global/formulario', 
        icone: 'vida-global',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_vida_global',
            label: 'Iniciando nova cotação Vida Global'
        }
    },
    {
        titulo: 'Acidentes Pessoais', 
        url: '/cotacao/acidentes_pessoais/formulario', 
        icone: 'account-injury',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_acidentes_pessoais',
            label: 'Iniciando nova cotação Acidentes Pessoais'
        }
    },
    {
        titulo: 'Viagem', 
        url: '/cotacao/viagem/formulario', 
        icone: 'bag-suitcase',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_viagem',
            label: 'Iniciando nova cotação Viagem'
        }
    },
    {
        titulo: 'Aluguel', 
        url: '/cotacao/aluguel/formulario', 
        icone: 'key-chain-variant',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_aluguel',
            label: 'Iniciando nova cotação Aluguel'
        }
    },
    {
        titulo: 'Bike', 
        url: '/cotacao/bike/formulario', 
        icone: 'bicycle',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_bike',
            label: 'Iniciando nova cotação Bike'
        }
    },
    {
        titulo: 'Celular', 
        url: '/cotacao/celular/formulario', 
        icone: 'smartphone',
        analytics: {
            type: 'click',
            category: 'nova_cotacao_celular',
            label: 'Iniciando nova cotação Celular'
        }
    }
];

export const menuPrincipal = [
    {
        titulo: 'Nova Cotação',
        url: '',
        icone: 'calculator',
        open: false,
        active: false,
        justMobile: true,
        justMenuMobile: false,
        justRoot: false,
        subList: menuCotacao,
        showIfAuthorizedName: "BOTAO_NOVA_COTACAO",
    },
    {
        titulo: 'Painel Administrativo',
        url: '/corretoras',
        icone: 'heroBriefcase',
        open: false,
        active: false,
        justMobile: true,
        justMenuMobile: true,
        justRoot: true,
        subList: [],
        showIfAuthorizedName: true,
    },
    {
        titulo: 'Cotações', 
        url: '/cotacoes', 
        icone: 'view-list', 
        open: false,
        active: false,
        justMobile: false,
        justMenuMobile: false,
        justRoot: false,
        subList: [],
        showIfAuthorizedName: true,
    },
    {
        titulo: 'Dashboard', 
        url: '/dashboard', 
        icone: 'view-dashboard', 
        open: false,
        active: false,
        justMobile: false,
        justMenuMobile: false,
        justRoot: false,
        subList: [],
        showIfAuthorizedName: "DASHBOARD",
    },
    {
        titulo: 'Tarefas', 
        url: '/tarefas', 
        icone: 'heroClipboardDocument', 
        open: false,
        active: false,
        justMobile: false,
        justMenuMobile: true,
        justRoot: false,
        subList: [],
        showIfAuthorizedName: "TAREFAS",
    },
    {
        titulo: 'Clientes',
        url: '/clientes',
        icone: 'heroUsers',
        justMenuMobile: true,
        active: false,
        subList: [],
        showIfAuthorizedName: "CLIENTES",
    },
    {
        titulo: 'Sincronizações',
        url: null,
        icone: 'heroArrowPath',
        active: false,
        open: false,
        justMobile: false,
        justMenuMobile: true,
        justRoot: false,
        subList: [
            { titulo: 'Propostas',   url: '/propostas',   icone: 'heroDocumentTextSolid',         active: false, justAdmin: false, showIfAuthorizedName: 'DOCUMENTOS' },
            { titulo: 'Apólices',   url: '/apolices',   icone: 'heroShieldCheckSolid',      active: false, justAdmin: true, showIfAuthorizedName: 'DOCUMENTOS' },
            { titulo: 'Extratos', url: '/extratos', icone: 'heroDocumentCurrencyDollarSolid', active: false, justAdmin: true, showIfAuthorizedName: 'DOCUMENTOS' },
            { titulo: 'Parcelas pendentes', url: '/parcelas-pendentes', icone: 'heroRectangleStackSolid', active: false, justAdmin: true, showIfAuthorizedName: 'PARCELAS' },
            // { titulo: 'Renovações', url: '/renovacoes-pendentes', icone: 'heroDocumentPlusSolid', active: false, justAdmin: true, showIfAuthorizedName: true },
        ],
        showIfAuthorizedName: 'SINCRONIZACOES',
    },
    {
        titulo: 'Negócios', 
        url: null, 
        icone: 'heroListBullet', 
        open: false,
        active: false,
        justMobile: false,
        justMenuMobile: true,
        justRoot: false,
        subList: [
            { titulo: 'Funil de Vendas',    url: '/funil-de-vendas', icone: 'heroFunnelSolid',   active: false, justAdmin: false, showIfAuthorizedName: "NEGOCIOS"  },
            { titulo: 'Lista de Negócios',  url: '/lista-negocios',  icone: 'heroChartBarSolid', active: false, justAdmin: false, showIfAuthorizedName: "NEGOCIOS"  },
        ],
        showIfAuthorizedName: "NEGOCIOS",
    },
    {
        titulo: 'Minhas plataformas', 
        url: null, 
        icone: 'heroLink', 
        open: false,
        active: false,
        justMobile: false,
        justMenuMobile: true,
        justRoot: false,
        showIfAuthorizedName: true,
        subList: [
            {
                titulo: 'Online', 
                url: '/online', 
                icone: 'heroComputerDesktopSolid', 
                open: false,
                active: false,
                justMobile: false,
                justMenuMobile: true,
                justRoot: false,
                subList: [],
                showIfAuthorizedName: "CORRETOR_DIGITAL",
            },
        ],
    },
    {
        titulo: 'Atendimento instantâneo',
        url: '/atendimento-ia',
        icone: 'chatbot-speech-bubble',
        subList: [],
        showIfAuthorizedName: !isMobileDevice(),
    },
    {
        titulo: 'Configurações',
        url: null,
        icone: 'heroCog8Tooth',
        active: false,
        open: false,
        justMobile: true,
        justMenuMobile: true,
        justRoot: false,
        subList: [
            {
                icone: "heroUserGroupSolid",
                titulo: "Usuários e permissões",
                url: "/config-usuarios",
                active: false,
                showIfAuthorizedName: "USUARIOS_PERMISSOES",
            },
            {
                icone: "heroBuildingOffice2Solid",
                titulo: "Seguradoras",
                url: "/config-seguradoras",
                active: false,
                showIfAuthorizedName: "SEGURADORAS",
            },
            {
                icone: "heroClipboardDocumentListSolid",
                titulo: "Coberturas",
                url: "/config-coberturas",
                active: false,
                showIfAuthorizedName:"COBERTURAS",
            },
        ],
        showIfAuthorizedName: "BOTAO_CONFIGURACOES",
    },
    {
        titulo: 'Atendimento humanizado',
        url: '/suporte',
        icone: 'faceAgentOutline',
        open: false,
        active: false,
        external: false,
        justMobile: true,
        justMenuMobile: true,
        justRoot: false,
        subList: [],
        showIfAuthorizedName: "SUPORTE",
    }
];

export const menuReduzido = [
    {
        titulo: 'Configurações',
        url: '/configuracoes',
        icone: 'tools',
        active: false,
        open: false,
        justMobile: true,
        justRoot: false,
        subList: [],
        showIfAuthorizedName: "BOTAO_CONFIGURACOES",
    },
    {
        titulo: 'Suporte',
        url: '/suporte',
        icone: 'lifebuoy',
        open: false,
        active: false,
        external: false,
        justMobile: true,
        justRoot: false,
        subList: [],
        showIfAuthorizedName: "SUPORTE",
    }
];
